<template>
  <a-card :bordered="false" title="佣金规则/设置佣金">
    <a-form-model
      ref="ruleForm"
      :label-col="baseItemLayout.labelCol"
      :wrapper-col="baseItemLayout.wrapperCol">
      <a-form-model-item label="商品ID">{{ proId }}</a-form-model-item>
      <a-form-model-item label="商品名称">{{ proName }}</a-form-model-item>
      <a-form-model-item label="佣金内容" prop="ruleName">
        <custom-page-table
          style="width: 500px;"
          ref="table"
          :queryParams="queryCommission"
          :columns="columnsCommission"
          :requestPromise="getRequestPromise"
        >
          <span slot="action" slot-scope="rowItem">
            <a @click="showModal(rowItem.record.optionId)" style="margin-right: 10px">设置佣金</a>
            <a v-if="rowItem.record.ruleContext === '已设置'" @click="makeEmpty(rowItem.record.optionId)">清空</a>
          </span>
        </custom-page-table>
      </a-form-model-item>
    </a-form-model>
    <a-modal
      title="设置佣金"
      :footer="null"
      :width="Number(proCatalog) !== 3 && Number(proCatalog) !== 8?1200:800"
      centered
      :afterClose="afterClose"
      :dialog-style="{ top: '20px' }"
      :visible="visible"
      @cancel="visible=false">
      <a-tabs v-if="planPriceList&&planPriceList.length>0" type="card" v-model="ratePlanId" @change="callPlanPriceBack">
        <a-tab-pane v-for="item in planPriceList" :key="item.ratePlanId" :tab="item.ratePlanName"></a-tab-pane>
      </a-tabs>
      <a-row :span="24">
        <a-col :span="16" v-if="Number(proCatalog) !== 3 && Number(proCatalog) !== 8">
          <a-calendar :mode="mode" @panelChange="onPanelChange" @select="onDateSelected" :disabledDate="disabledDate">
            <div style="width: 100%;" slot="dateCellRender" slot-scope="value">
              <a-checkbox
                v-if="!isDisabledDate(value)&&!getDisabledDate(value)&&checkPrice(value)"
                class="item-checkbox" :checked="isSelected(value)" style="width: 40px">
              </a-checkbox>
              <div v-for="item in getListData(value)" :key="item.content" style="font-size: 12px">{{
                  item.content
                }}
              </div>
            </div>
          </a-calendar>
          <a-checkbox v-model="selectedAll" :disabled="disabledAll" class="all-select" @change="selectedAllDate">全选
          </a-checkbox>
        </a-col>
        <a-col :span="Number(proCatalog) !== 3 && Number(proCatalog) !== 8?8:24">
          <a-table rowKey="groupId" :pagination="false" :columns="columns" :data-source="dataList">
            <span slot="groupCommission" slot-scope="text, record, index">
              <a-input-number style="width: 150px;" v-model="dataList[index].groupCommission" :min="0" :max="10000"
                              :precision="2" placeholder="请输入"/>
          </span>
            <span slot="action" slot-scope="text, record, index">
              <a @click="newGroup(2,index)">编辑</a>
              <a style="margin-left: 10px;" @click="deleteGroup(record)">删除</a>
          </span>
          </a-table>
          <a-button @click="newGroup(1)" style="width: 100%;margin: 20px 0;" icon="plus" type="dashed">
            添加分组
          </a-button>
          <div>
            <a-button @click="onSubmit" type="primary">保存</a-button>
            <a-button style="margin-left: 20px;" @click="onReset">重置</a-button>
          </div>
        </a-col>
      </a-row>
    </a-modal>
    <a-modal title="选择分销员分组" :footer="null" :width="650" :visible="staffGroupVisible"
             @cancel="staffGroupVisible = false">
      <custom-page-table
        ref="tableGroup"
        :columns="columnsGroup"
        :queryParams="queryGroup"
        :requestPromise="getRequestPromiseGroup">
        >
        <span slot="action" slot-scope="rowItem">
            <a-button type="primary" size="small" @click="selectStaffGroup(rowItem.record)">选择</a-button>
          </span>
      </custom-page-table>
    </a-modal>
  </a-card>
</template>

<script>
import moment from 'moment'
import formMixins from '../../../../utils/mixins/formMixins'

export default {
  name: 'CommissionCalendar',
  mixins: [formMixins],
  data() {
    return {
      moment,
      disabledDate(current) {
        // Can not select days before today and today
        return current && current < moment().startOf('day')
      },
      visible: false,
      staffGroupVisible: false,
      mode: 'month',
      selectedAll: false,
      monthStr: '',
      selectedDateList: [],
      priceDataList: [],
      dataList: [],
      queryCommission: {
        proId: this.$route.query.proId,
        ruleId: this.$route.query.ruleId
      },
      queryGroup: {
        groupIdList: null,
        ruleType: 7
      },
      columns: [
        {
          title: '成员分组',
          dataIndex: 'groupName'
        },
        {
          title: '设置佣金',
          dataIndex: 'groupCommission',
          scopedSlots: { customRender: 'groupCommission' }
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ],
      columnsCommission: [
        {
          title: '套餐ID',
          dataIndex: 'optionId'
        },
        {
          title: '套餐名称',
          dataIndex: 'optionName'
        },
        {
          title: '规则内容',
          dataIndex: 'ruleContext'
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ],
      columnsGroup: [
        {
          title: 'ID',
          dataIndex: 'dataId'
        },
        {
          title: '分组名称',
          dataIndex: 'name'
        },
        {
          title: '分组类型',
          dataIndex: 'catalogStr'
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ],
      proId: this.$route.query.proId,
      proName: this.$route.query.proName,
      proCatalog: this.$route.query.proCatalog,
      optionId: '',
      planPriceList: [],
      ratePlanId: undefined,
      editOrSave: 1,
      editIndex: undefined,
      disabledAll: false
    }
  },
  watch: {
    ratePlanId(v) {
      if (Number(this.proCatalog) !== 3 && Number(this.proCatalog) !== 8) {
        this.getProPriceInfo()
      }
    },
    dataList(v) {
      this.changeDataList(v)
    }
  },
  mounted() {
    this.$store.commit('SET_MENU_HEAD_CONFIG', [
      { name: 'CommissionHelper', title: '佣金分配记录' },
      { name: 'CommissionRule', title: '佣金规则' }
    ])
    this.monthStr = this.getDateHelper().getCurrentFormatDate('YYYY-MM')
  },
  methods: {
    onSubmit() {
      if (this.selectedDateList.length === 0 && Number(this.proCatalog) !== 3 && Number(this.proCatalog) !== 8) {
        this.$message.error('请选择日期')
        return false
      }
      if (this.dataList && this.dataList.length > 0) {
        for (let i = 0; i < this.dataList.length; i++) {
          if (this.dataList[i].groupCommission === null) {
            this.$message.error('请设置佣金')
            return false
          }
        }
      }
      this.saveData()
    },
    getDateList(date) {
      let arr = []
      if (date && date.length > 0) {
        date.forEach((item) => {
          let obj = {
            date: item
          }
          arr.push(obj)
        })
      }
      return arr
    },
    saveData() {
      let params = {
        optionId: this.optionId,
        proCatalog: this.proCatalog,
        proId: this.proId,
        ratePlanId: this.ratePlanId ? this.ratePlanId : null,
        commissionCalendarList: Number(this.proCatalog) === 3 || Number(this.proCatalog) === 8 ? [{ date: '3019-01-01' }] : this.getDateList(this.selectedDateList),
        groupCommissionList: this.dataList && this.dataList.length > 0 ? this.dataList : null
      }
      this.getHttpServices()
        .getPayApiService()
        .post('commissionRule/save/calendar/commission', params)
        .then(res => {
          this.$message.success('成功保存')
          if (Number(this.proCatalog) === 3 || Number(this.proCatalog) === 8) {
            this.visible = false
          }
        })
        .catch(reason => this.showNetWorkErrorMessage(reason))
    },
    deleteGroup(record) {
      let arr = this.dataList.filter(item => item.groupId !== record.groupId)
      this.dataList = [...arr]
    },
    selectStaffGroup(obj) {
      if (this.editOrSave === 1) {
        let params = {
          groupId: obj.dataId,
          groupCommission: null,
          groupName: obj.name
        }
        this.dataList.push(params)
      } else {
        this.dataList[this.editIndex].groupId = obj.dataId
        this.dataList[this.editIndex].groupName = obj.name
        this.changeDataList(this.dataList)
      }
      this.staffGroupVisible = false
    },
    changeDataList(list) {
      let arr = []
      if (list && list.length > 0) {
        arr = list.map((item) => {
          return item.groupId
        })
      }
      this.queryGroup.groupIdList = arr && arr.length > 0 ? arr : null
    },
    //分销员分组表格数据
    onReset() {
      if (this.dataList && this.dataList.length > 0) {
        this.dataList.forEach((item) => {
          item.groupCommission = null
        })
      }
    },
    getRequestPromiseGroup(params) {
      return this.getHttpServices().getUserService().post('merchant/v2/group/getCommissionGroupList', params)
    },
    //切换价格计划
    callPlanPriceBack(key) {
      this.getLogUtils().logWithTag('==callPlanPriceBack', key)
      this.ratePlanId = key
      this.dataList = []
    },
    //获取全月的接口
    getProPriceInfo() {
      let params = {
        optionId: this.optionId,
        proId: this.$route.query.proId,
        startDateStr: this.monthStr + '-01'
        // ratePlanId:this.ratePlanId
      }
      if (this.ratePlanId) {
        params.ratePlanId = this.ratePlanId
      }
      this.getHttpServices().getProService().post('priceCalendar/fullMonthPrice', params)
        .then(res => {
          this.priceDataList = res.calendarDayVOs
          this.selectedDateList = []
          this.selectedAll = false
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    ratePlan() {
      let params = {
        limitDto: {
          pageSize: 100,
          pageNum: 1
        },
        optionId: this.optionId,
        proId: this.proId
      }
      this.getHttpServices()
        .getPayApiService()
        .post('commissionRule/get/rateplan', params)
        .then(res => {
          this.planPriceList = res.data
          if (res.data && res.data.length > 0) {
            this.ratePlanId = Number(res.data[0].ratePlanId)
          }
        })
        .catch(reason => this.showNetWorkErrorMessage(reason))
    },
    makeEmpty(id) {
      let params = {
        optionId: id,
        ruleId: this.$route.query.ruleId,
        proId: this.$route.query.proId
      }
      this.getHttpServices()
        .getPayApiService()
        .post('commissionRule/del/option', params)
        .then(res => {
          this.$message.success('成功清空')
          this.$refs.table.refresh(true)
        })
        .catch(reason => this.showNetWorkErrorMessage(reason))
    },
    afterClose() {
      this.selectedDateList = []
      this.$refs.table.refresh(true)
    },
    getRequestPromise(params) {
      return this.getHttpServices().getPayApiService().post('commissionRule/get/OptionList', params)
    },
    showModal(id) {
      this.visible = true
      this.optionId = id
      this.dataList = []
      if (Number(this.proCatalog) === 3 || Number(this.proCatalog) === 8) {
        this.getCalendarCommission()
      }
      if (Number(this.proCatalog) === 2) {
        this.ratePlan()
      } else if (Number(this.proCatalog) !== 3 && Number(this.proCatalog) !== 8) {
        this.getProPriceInfo()
      }
    },
    goBack() {
      this.$router.go(-1)
    },
    newGroup(type, index) {
      this.editOrSave = type
      this.editIndex = index
      if ((this.selectedDateList && this.selectedDateList.length > 0) || (Number(this.proCatalog) === 3 || Number(this.proCatalog) === 8)) {
        this.staffGroupVisible = true
        this.$nextTick(() => {
          this.$refs.tableGroup.refresh(true)
        })
      } else {
        this.$message.error('请选择日期')
      }
    },
    getListData(value) {
      let listData = []
      const dateStr = this.getDateHelper().getFormatDate(value)
      const priceItem = this.priceDataList.find((item, index, arr) => item.priceDate === dateStr)
      if (priceItem) {
        if (priceItem.mfAuditPrice) {
          listData.push({ type: 'success', content: '同行价    ¥' + priceItem.mfAuditPrice })
        }
        if (priceItem.advicePrice) {
          listData.push({ type: 'success', content: '销售价    ¥' + priceItem.advicePrice })
        }
        if (priceItem.commissionPrice) {
          listData.push({ type: 'success', content: '佣金    ¥' + priceItem.commissionPrice })
        }
      }
      return listData
    },
    checkPrice(value) {
      const dateStr = this.getDateHelper().getFormatDate(value)
      const priceItem = this.priceDataList.find((item, index, arr) => item.priceDate === dateStr)
      return !!priceItem
    },
    selectedAllDate: function(e) {
      if (e.target.checked) {
        const newList = []
        let days = this.getDateHelper().getDaysInMonth(this.monthStr + '-01')
        this.getLogUtils().logWithTag('days', days)
        for (let i = 1; i <= days; i++) {
          newList.push(this.monthStr + '-' + (i > 9 ? i : '0' + i))
        }
        let nowDate = moment(new Date()).format('YYYY-MM-DD')
        let index = newList.indexOf(nowDate)
        let dateList = []
        let sliceList = []
        if (index !== -1) {
          sliceList = newList.slice(index, newList.length)
        } else {
          sliceList = newList
        }
        if (this.priceDataList && this.priceDataList.length > 0) {
          sliceList.forEach((date) => {
            this.priceDataList.forEach((item) => {
              if (item.priceDate === date) {
                dateList.push(date)
              }
            })
          })
        }
        this.selectedDateList = dateList
      } else {
        this.selectedDateList = []
      }
      this.getLogUtils().errorWithTag('this.selectedDateList', this.selectedDateList)
      this.selectedAll = e.target.checked
      this.getCalendarCommission()
    },
    onPanelChange(date, mode) {
      this.mode = mode
      this.getLogUtils().logWithTag('===onPanelChange mode===', mode)
      this.getLogUtils().logWithTag('===onPanelChange date===', moment(date).format('YYYY-MM-DD'))
      if (mode === 'month') {
        this.selectedAll = false
        this.monthStr = this.getDateHelper().formatDate(date, 'YYYY-MM')
        this.getLogUtils().logWithTag('===this.monthStr ===', this.monthStr)
        let nowMouth = moment(new Date()).format('YYYY-MM')
        let diffMonths = this.getDateHelper().diffMonths(nowMouth, this.monthStr)
        this.disabledAll = diffMonths >= 0 ? false : true
        this.getProPriceInfo()
      }
    },
    //判断选项是否禁用(非当前月的数据禁用)
    isDisabledDate(value) {
      const dateStr = this.getDateHelper().formatDate(value, 'YYYY-MM')
      return dateStr !== this.monthStr
    },
    isSelected(momentValue) {
      const dateStr = this.getDateHelper().getFormatDate(momentValue)
      const index = this.selectedDateList.findIndex((item, index, arr) => dateStr === item)
      return index >= 0
    },
    getDisabledDate(current) {
      // this.getLogUtils().logWithTag('==isDisabledDate===',current)
      return current && current < moment().startOf('day')
    },
    getCalendarCommission() {
      let dateList = this.selectedDateList
      let params = {
        optionId: this.optionId,
        proId: this.proId,
        ratePlanId: this.ratePlanId ? this.ratePlanId : null,
        date: Number(this.proCatalog) === 3 || Number(this.proCatalog) === 8 ? '3019-01-01' : (dateList && dateList.length > 0) ? dateList[dateList.length - 1] : ''
      }
      this.getHttpServices()
        .getPayApiService()
        .post('commissionRule/get/calendar/commission', params)
        .then(res => {
          this.dataList = res
        })
        .catch(reason => this.showNetWorkErrorMessage(reason))
    },
    onDateSelected(date) {
      if (this.mode === 'year') {
        this.mode = 'month'
        this.monthStr = this.getDateHelper().formatDate(date, 'YYYY-MM')
        this.getProPriceInfo()
      } else {
        const dateStr = this.getDateHelper().getFormatDate(date)
        const priceItem = this.priceDataList.find((item, index, arr) => item.priceDate === dateStr)
        if (!!priceItem) {
          if (this.isSelected(date)) {
            this.selectedDateList = this.selectedDateList.filter((item, index, arr) => dateStr !== item)
          } else {
            this.selectedDateList.push(dateStr)
          }
        }
      }
      this.getCalendarCommission()
      this.getLogUtils().logWithTag('==onDateSelected dateStr===', this.selectedDateList)
    }
  }
}
</script>

<style lang="less" scoped>
.all-select {
  position: absolute;
  right: 320px;
  top: 15px;
}

</style>
<style lang="less">
.item-checkbox {
  position: absolute;
  top: 6px;
}
</style>